/**
 * LIST-CELL
 * Cell component for a list item
 */

import { faCaretDown, faInfoCircle } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import React from "react"

interface OwnProps {
  children?: any
  text?: string | React.ReactNode
  onHelp?: Function
  width?: number
  isFlex?: boolean
  isBold?: boolean
  onClick?: Function
  onSort?: Function
  className?: string
}

function ListCell(props: OwnProps) {
  function click() {
    if (props.onClick) {
      props.onClick()
    }
  }

  //Click on info info
  function clickHelp(e: any) {
    e.stopPropagation()
    if (props.onHelp) {
      props.onHelp()
    }
  }

  function getClassName() {
    let className = "list-cell flex"
    if (props.onClick) className += " _hover"
    if (props.className) className += " " + props.className
    return className
  }

  function getStyle() {
    if (props.isFlex) return { flex: 1 }
    const width = props.width ? props.width : 38
    return { minWidth: width + "px", maxWidth: width + "px" }
  }

  function sort() {
    if (props.onSort) {
      props.onSort()
    }
  }

  return (
    <div className={getClassName()} style={getStyle()}>
      {props.text && (
        <span className={"list-cell-title flex " + (props.isBold ? "list-cell-bold" : "")} onClick={click}>
          {props.onSort ? (
            <div className="list-cell-text _hover" onClick={() => sort()}>
              {props.text}
              &nbsp;
              <FontAwesomeIcon icon={faCaretDown} />
            </div>
          ) : (
            <div className="list-cell-text">{props.text}</div>
          )}

          <div className="flex1">
            {props.onHelp && <FontAwesomeIcon icon={faInfoCircle} onClick={(e: any) => clickHelp(e)} />}
          </div>
        </span>
      )}

      {props.children}
    </div>
  )
}

export default ListCell
